import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';

import FormikInput from '../../../../components/Inputs/FormikInput';
import Alert from '../../../../components/Alert';
import FormComponent from '../../../../components/Form';

import { onUpdateDiscountAction } from '../../../../redux/actions/users/actions';
import Tooltip from '../../../../components/Tooltip';

const SetDiscountForm = ({ user, formRef, setOpen }) => {
  const dispatch = useDispatch();
  const isActiveUserLevelSystem = !!user?.user_level

  const handleSubmit = async (values, actions) => {
    try {
      await dispatch(onUpdateDiscountAction(user.id, values.discount));
      setOpen(false);
    } catch (error) {
      actions.setErrors(error);
    }
  };

  const onChangeDiscount = (e, onChange) => {
    const { value } = e.target;

    if (!value) {
      return onChange('discount', '0');
    }

    if (/^\d{0,3}$/.test(value)) {
      return onChange('discount', String(Math.min(100, parseInt(value, 10))));
    }
  };

  return (
    <Formik
      onSubmit={(values, actions) => handleSubmit(values, actions)}
      initialValues={{ discount: String(user.discount) }}
      validateOnChange={false}
      validateOnBlur={false}
      innerRef={formRef}
    >
      {({ errors, handleSubmit, setFieldValue }) => (
        <>
          {errors.length && <Alert text={errors} />}
          <Alert text="Will not be applied to services with custom rates." type="warning" />

          <FormComponent handleSubmit={handleSubmit}>
            <Field
              component={FormikInput}
              setFieldValue={setFieldValue}
              onChange={(e) => onChangeDiscount(e, setFieldValue)}
              label={isActiveUserLevelSystem ? (
                <>
                  Discount, %
                  {' '}
                  <Tooltip
                    placement="top"
                    text={(
                      <p>
                        To apply the automatic discount
                        <br />
                        {' '}
                        to this user based
                        <br />
                        on the User level system,
                        <br />
                        either erase the field
                        <br />
                        or input '0' and save changes
                      </p>
                    )}
                    tooltipClass="tooltip__top"
                  >
                    <span className="fas fa-info-circle cursor-help" />
                  </Tooltip>
                </>
              ) : 'Discount, %'}
              name="discount"
              focus
            />
          </FormComponent>
        </>
      )}
    </Formik>
  );
};

SetDiscountForm.propTypes = {
  user: PropTypes.object,
  formRef: PropTypes.object,
  setOpen: PropTypes.func,
};

export default SetDiscountForm;
